import { LayerDefinition } from './types';

export const lenticularDefinition: LayerDefinition = {
  id: 'lenticular',
  name: 'Lenticular Cloud Index',
  category: 'forecast',
  categoryLabel: 'Forecast Quality Scoring',
  icon: '🛸',
  description: 'Mountain wave cloud formation model indicates where conditions are favorable for Lenticular cloud formation. Colored area does not represent the likely extent of a Lenticular, but only where conditions are favorable.',
  sourceModels: ['ecmwf', 'rrfs', 'rdps', 'gdps'],
  outputModels: ['ecmwf', 'rrfs', 'rdps', 'gdps'],
  config: {
    modes: ['cap', 'trapped', 'socked'],
    defaultMode: 'cap',
    defaultOpacity: 0.8
  }
};

export default lenticularDefinition;
